export const environment = {
    production: false,
    serviceUrl: 'https://api.factmas.com/api/',
    hostBack: 'https://api.factmas.com',
    aplicacionesId: 21,
    nombreAplicacion: '+Factura',
    sparrowreport: 'https://api.sparrow.coal.mx/',
    PublicStripeKey: 'pk_live_51MPYVLH0xRpvGeXXgKoRcOtSBVZSsba1vLScQPYM22ukAYmLDGwcRvb9cZU1KX1hnI8eONHeDqJnLcI4DQcm34Bd00Jg7eiMQG',
    payments: 'https://api.payments.coal.mx/',
    envName: 'develop',
    expireSession: 60 // min
};
